import { useEffect, useState } from "react";
import { fetchStarterProducts } from "../../../services/RegistryStarterService";

const LOADING_STATE = { status: "loading", products: [] };

/** Loads a starter template's catalogue products. `status` is "loading" | "ready" | "error". */
const useStarterProducts = (template) => {
	const [state, setState] = useState(LOADING_STATE);
	const [attempt, setAttempt] = useState(0);

	useEffect(() => {
		let isCancelled = false;
		setState(LOADING_STATE);
		fetchStarterProducts(template)
			.then((products) => {
				if (!isCancelled) setState({ status: "ready", products });
			})
			.catch((error) => {
				console.error("Failed to load starter products:", error);
				if (!isCancelled) setState({ status: "error", products: [] });
			});
		return () => {
			isCancelled = true;
		};
	}, [template, attempt]);

	return { ...state, retry: () => setAttempt((previous) => previous + 1) };
};

export default useStarterProducts;
